import PropTypes from 'prop-types'

import { ElectricVehicleState } from '../../models/electric/electric-vehicle-state-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { idPropType } from '../common/id-prop-type'

const {
    BATTERY_HEALTH,
    BATTERY_LEVEL,
    ESTIMATED_TIME_TO_CHARGE,
    EV_ROUTING_ENABLED,
    FUEL_TYPE,
    IS_CHARGING,
    LAST_MODIFIED,
    OBJECT_ID,
    RANGE
} = ElectricVehicleState

/**
 * @typedef {object} ElectricVehicleState
 * @property {number} [batteryHealth]               - Battery state of health of the Electric Vehicle (EV) state
 * @property {number} [batteryLevel]                - Battery level of the Electric Vehicle (EV) state
 * @property {ISO8601} [estimatedTimeToCharge]      - Date of the Electric Vehicle (EV) state
 * @property {boolean} [evRoutingEnabled]           - Is EV routing enabled for the vehicle
 * @property {string} [fuelType]                    - Fuel type of the Electric Vehicle (EV) state
 * @property {boolean} [isCharging]                 - Whether the electric vehicle is being charged
 * @property {ISO8601} [lastModified]               - When the Electric Vehicle (EV) state was last modified
 * @property {Id} [objectId]                        - Object id unique identifier
 * @property {number} [range]                       - Range of the Electric Vehicle (EV) state
 */
export const electricVehicleStatePropType = PropTypes.shape({
    [BATTERY_HEALTH]: PropTypes.number,
    [BATTERY_LEVEL]: PropTypes.number,
    [ESTIMATED_TIME_TO_CHARGE]: iso8601PropType,
    [EV_ROUTING_ENABLED]: PropTypes.bool,
    [FUEL_TYPE]: PropTypes.string,
    [IS_CHARGING]: PropTypes.bool,
    [LAST_MODIFIED]: iso8601PropType,
    [OBJECT_ID]: idPropType,
    [RANGE]: PropTypes.number
})
